// Method to actually validate all required form fields
const validateForm = values => {
    // Temp errors object
    let errors = {};

    // Doesn't validate anything when it's pix
    if (values.paymentType === "pix") {
        return errors;
    }

    // The regexes for values to be validated from
    let zipRegex = new RegExp("^[0-9]{5}-[0-9]{3}$");
    let taxVatRegex = new RegExp("^\\d{3}.\\d{3}.\\d{3}-\\d{2}$");
    let emailRegex = new RegExp("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$");

    if (!values.method) {
        errors["method"] = "Esse campo é obrigatório.";
    }

    if (!values.cardName) {
        errors["cardName"] = "Esse campo é obrigatório.";
    } else if (values.cardName && values.cardName.length < 5) {
        errors["cardName"] = "Insira no mínimo 5 caracteres.";
    }

    if (values.cardNumber.length < 16) {
        errors["cardNumber"] = "Esse campo é obrigatório.";
    }

    if (values.cardSecurityCode.length < 3) {
        errors["cardSecurityCode"] = "Esse campo é obrigatório.";
    }

    if (values.cardValidity.length < 5) {
        errors["cardValidity"] = "Esse campo é obrigatório.";
    }

    if (values.paymentType === "credit" && !values.cardInstallments) {
        errors["cardInstallments"] = "Esse campo é obrigatório.";
    }

    if (!values.cardTerm) {
        errors["cardTerm"] = "Esse campo é obrigatório.";
    }

    if (!values.isDefaultNf) {
        if (!values.nfTaxvat) {
            errors.nfTaxvat = "Esse campo é obrigatório.";
        } else if (values.nfTaxvat && !taxVatRegex.test(values.nfTaxvat)) {
            errors.nfTaxvat = "Insira um CPF válido.";
        }

        if (!values.nfName) {
            errors["nfName"] = "Esse campo é obrigatório.";
        } else if (values.nfName && values.nfName.length < 5) {
            errors["nfName"] = "Insira no mínimo 5 caracteres.";
        }

        if (!values.nfEmail) {
            errors.nfEmail = "Esse campo é obrigatório.";
        } else if (
            values.nfEmail &&
            (
                !emailRegex.test(values.nfEmail) ||
                values.nfEmail.endsWith(".co")
            )
        ) {
            errors.nfEmail = "Insira um endereço de email válido.";
        }
    } else {
        delete errors.nfTaxvat;
        delete errors.nfName;
        delete errors.nfEmail;
    }

    if (!values.isDefaultBilling) {
        if (!values.billingPostcode) {
            errors.billingPostcode = "Esse campo é obrigatório.";
        } else if (values.billingPostcode && !zipRegex.test(values.billingPostcode)) {
            errors.billingPostcode = "Insira um CEP válido.";
        }

        if (!values.billingAddress) {
            errors.billingAddress = "Esse campo é obrigatório.";
        }

        if (!values.billingNumber) {
            errors.billingNumber = "Esse campo é obrigatório.";
        }

        if (!values.billingNeighborhood) {
            errors.billingNeighborhood = "Esse campo é obrigatório.";
        }

        if (!values.billingCity) {
            errors.billingCity = "Esse campo é obrigatório.";
        }

        if (!values.billingState) {
            errors.billingState = "Esse campo é obrigatório.";
        }

        if (!values.billingTelephone) {
            errors.billingTelephone = "Esse campo é obrigatório.";
        }
    } else {
        delete errors.billingPostcode;
        delete errors.billingAddress;
        delete errors.billingNumber;
        delete errors.billingNeighborhood;
        delete errors.billingCity;
        delete errors.billingState;
        delete errors.billingTelephone;
    }

    return errors;
}

export default validateForm;
